import en from './en';
import ru from './ru';
import es from './es';
import fr from './fr';

export {en, ru, es, fr};